(function () {
  function initCartIconAnimation() {
    var cartIcon = document.getElementById('cart-icon-bubble');
    if (!cartIcon) return;
    if (cartIcon.dataset.bumpAnimation === 'false') return;

    var bump = function () {
      cartIcon.classList.remove('cart-icon-bump');
      // Force reflow so the animation restarts if triggered again quickly.
      void cartIcon.offsetWidth;
      cartIcon.classList.add('cart-icon-bump');
    };

    var observer = new MutationObserver(bump);
    observer.observe(cartIcon, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartIconAnimation);
  } else {
    initCartIconAnimation();
  }
})();
